export const SELECT_ONE_TEXT = '-- Select one --';
export const SELECT_MULTI_TEXT = '-- Select one or more --';
export const USER_EMAIL_HINT_TEXT = 'You can enter multiple email addresses, separated by comma.';
